// import Definition from './Definition';

export default {
  priority: 13,
  path: 'definition',
  permissions: ['TimeAttendanceMenu/ShiftMenu/ShiftDefineMenu'],
  // component: Definition,
  component: load(() => import(/* webpackChunkName: "Shift-Definition" */ './Definition')),
  name: app.translate('routes.home.attendance.shift.Definition'),
  icon: 'content-paste',
  drawer: true,
};


